<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page delivery-collecting-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero noPrint">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar bbm-avatar-contain">
            <img
              src="/assets/ontheway.png"
              [alt]="'logo' | transloco"
            >
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'deliveryhero' | transloco }}
            </span>

            <h2>
              {{ 'delivery hero collecting' | transloco }}
            </h2>

            <p>
              {{ date || '-' }}
            </p>
          </div>

        </div>

        <button
          type="button"
          class="bbm-hero-icon"
          onclick="window.print()"
          [attr.aria-label]="'Print' | transloco"
        >
          <i class="fa-solid fa-print"></i>
        </button>

      </div>

    </section>

    <!-- ADMIN WAREHOUSE -->
    <section
      *ngIf="isAdmin"
      class="bbm-form-ticket noPrint"
    >
      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'Pospage' | transloco }}
          </span>

          <h3>
            {{ 'Pospage' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-form-grid">
        <div class="bbm-field bbm-field-wide">

          <label for="delivery-collecting-warehouse">
            {{ 'Pospage' | transloco }}
          </label>

          <select
            id="delivery-collecting-warehouse"
            class="bbm-control"
            [(ngModel)]="warehouseId"
            (change)="applyWareHouse(warehouseId)"
          >
            <option
              *ngFor="let el of allWareHouses"
              [value]="el.id"
            >
              {{ el.name }}
            </option>
          </select>

        </div>
      </div>
    </section>

    <!-- FILTERS -->
    <section class="bbm-form-ticket noPrint">

      <div class="bbm-form-head">
        <div>
          <span class="bbm-eyebrow">
            {{ 'delivery hero collecting' | transloco }}
          </span>

          <h3>
            {{ 'Filters' | transloco }}
          </h3>
        </div>
      </div>

      <div class="bbm-form-grid">

        <!-- DELIVERY HERO -->
        <div class="bbm-field">
          <label for="delivery-collecting-hero">
            {{ 'deliveryhero' | transloco }}
          </label>

          <select
            id="delivery-collecting-hero"
            class="bbm-control"
            [(ngModel)]="herosd"
            (change)="filterAllHeros()"
          >
            <option
              *ngFor="let hero of heros"
              [value]="hero.phone ?? hero.link ?? hero.id"
            >
              {{ hero.name }}
            </option>
          </select>
        </div>

        <!-- DAY -->
        <div class="bbm-field">
          <label for="delivery-collecting-date">
            {{ 'byday' | transloco }}
          </label>

          <div class="bb-booking-calendar-field" [dir]="isAr ? 'rtl' : 'ltr'">
            <button
              type="button"
              class="bb-booking-calendar-trigger"
              id="delivery-collecting-date"
              (click)="toggleDayCalendar()"
              [ngClass]="{
                'is-valid': date
              }"
            >
              <span>{{ getDayDisplay() }}</span>
              <i class="fa-solid fa-calendar-days"></i>
            </button>

            @if(showDayCalendar) {
            <div class="bb-booking-calendar-panel">
              <div class="bb-booking-calendar-head">
                <button type="button" (click)="previousDayCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
                </button>

                <strong>{{ getDayCalendarTitle() }}</strong>

                <button type="button" (click)="nextDayCalendarMonth()">
                  <i class="fa-solid" [ngClass]="isAr ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
                </button>
              </div>

              <div class="bb-booking-calendar-weekdays">
                @for(dayName of getDayCalendarWeekDays(); track dayName) {
                <span>{{ dayName }}</span>
                }
              </div>

              <div class="bb-booking-calendar-grid">
                @for(calendarDay of getDayCalendarDays(); track calendarDay.date.getTime()) {
                <button
                  type="button"
                  class="bb-booking-calendar-day"
                  [class.other-month]="!calendarDay.isCurrentMonth"
                  [class.today]="calendarDay.isToday"
                  [class.selected]="calendarDay.isSelected"
                  [disabled]="calendarDay.isDisabled"
                  (click)="selectDayCalendarDate(calendarDay.date)"
                >
                  {{ calendarDay.dayNumber }}
                </button>
                }
              </div>
            </div>
            }
          </div>
        </div>

      </div>

    </section>

    <!-- SUMMARY -->
    <section class="bbm-details-grid bbm-summary-grid bbm-section">

      <!-- TOTAL COLLECTED -->
      <div class="bbm-detail-chip bbm-detail-success bbm-detail-wide">
        <i class="fa-solid fa-sack-dollar"></i>

        <span>
          {{ 'total' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ totalCollected | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </strong>
      </div>

      <!-- ORDERS COUNT -->
      <div class="bbm-detail-chip bbm-detail-primary">
        <i class="fa-solid fa-receipt"></i>

        <span>
          {{ 'Orders' | transloco }}
        </span>

        <strong>
          {{ totalCount }}
        </strong>
      </div>

      <!-- TOTAL AMOUNT -->
      <div class="bbm-detail-chip bbm-detail-success">
        <i class="fa-solid fa-money-bill-wave"></i>

        <span>
          {{ 'amount' | transloco }}
        </span>

        <strong class="bbm-money-value">
          {{ totalAmount | number:'1.2-2' }}
          {{ 'egp' | transloco }}
        </strong>
      </div>

    </section>

    <!-- COLLECTION LIST -->
    <section class="bbm-records-section">

      <div class="bbm-list-head">
        <div>
          <span>
            {{ 'deliveryhero' | transloco }}
          </span>

          <h3>
            {{ 'delivery hero collecting' | transloco }}
          </h3>
        </div>

        <span
          *ngIf="!hasData"
          class="bbm-list-counter"
        >
          {{ collectedFromDH.length }}
        </span>
      </div>

      <!-- EMPTY STATE -->
      <div
        class="bbm-empty-state"
        *ngIf="hasData"
      >
        <app-nodata></app-nodata>
      </div>

      <!-- RECORDS -->
      <div
        class="bbm-ticket-list"
        *ngIf="!hasData"
      >
        <article
          class="bbm-ticket bbm-ticket-success"
          *ngFor="
            let value of collectedFromDH;
            let i = index;
            trackBy: trackByCollection
          "
        >

          <!-- CARD TOP -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i class="fa-solid fa-motorcycle"></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'Orders' | transloco }}
                </span>

                <h3 class="bbm-code-value">
                  #{{ value.order_id }}
                </h3>

                <div class="bbm-badges-row">
                  <span class="bbm-badge bbm-badge-success">
                    <i class="fa-solid fa-check"></i>

                    {{ 'delivery hero collecting' | transloco }}
                  </span>
                </div>
              </div>

            </div>

            <button
              type="button"
              class="bbm-action-btn bbm-action-danger bbm-icon-action noPrint"
              (click)="delete(value.id)"
              [attr.aria-label]="'delete' | transloco"
            >
              <i class="fa-solid fa-xmark"></i>
            </button>

          </div>

          <!-- DETAILS -->
          <div class="bbm-details-grid">

            <!-- COLLECTED AMOUNT -->
            <div class="bbm-detail-chip bbm-detail-success bbm-detail-wide">
              <i class="fa-solid fa-wallet"></i>

              <span>
                {{ 'amount' | transloco }}
              </span>

              <strong class="bbm-money-value">
                {{ value.amount_collected | number:'1.2-2' }}
                {{ 'egp' | transloco }}
              </strong>
            </div>

            <!-- DELIVERY HERO -->
            <div class="bbm-detail-chip">
              <i class="fa-solid fa-motorcycle"></i>

              <span>
                {{ 'deliveryhero' | transloco }}
              </span>

              <strong class="bbm-code-value">
                {{ formatDeliveryHero(value.sub_dilivery_id) }}
              </strong>
            </div>

            <!-- ORDER -->
            <div class="bbm-detail-chip">
              <i class="fa-solid fa-receipt"></i>

              <span>
                {{ 'Orders' | transloco }}
              </span>

              <strong class="bbm-code-value">
                {{ value.order_id }}
              </strong>
            </div>

          </div>

        </article>
      </div>

      <!-- LOAD MORE -->
      <div
        *ngIf="isLoadingMore"
        class="bbm-loader noPrint"
      >
        <span
          class="bbm-loader-spinner"
          aria-hidden="true"
        ></span>

        <span>
          {{ 'Loading...' | transloco }}
        </span>
      </div>

      <!-- END OF LIST -->
      <div
        *ngIf="
          !hasData &&
          !isFiltering &&
          currentPage >= lastPage
        "
        class="bbm-end-state noPrint"
      >
        {{ 'End of list' | transloco }}
      </div>

    </section>

  </div>
</div>